export type OwnershipType =
  | 'CORVEHICLECUSTOMERTYPE_OPERATOR'
  | 'CORVEHICLECUSTOMERTYPE_OWNER'
  | 'CORVEHICLECUSTOMERTYPE_USER'
  | 'CORVEHICLECUSTOMERTYPE_MANAGER'
  | 'CORVEHICLECUSTOMERTYPE_INVOICE';
